import React from 'react';

import { Box, HStack, Stack, Wrap, WrapItem } from '@chakra-ui/react';
import map from 'lodash/map';

import { Tag } from 'components/DataDisplay';
import { CustomTooltip } from 'components/DataDisplay/Tooltip/CustomTooltip';

export const renderCriteria = ({ row }) => {
  // Check the tag key list length (as the tag render below does) so an empty
  // list shows "-" instead of a blank cell.
  if (
    row?.criteria &&
    (row?.criteria?.region ||
      row?.criteria?.resource_groups ||
      row?.criteria?.tag_keys_condition?.key?.length ||
      row?.criteria?.tag_key_values_condition)
  ) {
    const {
      region,
      resource_groups,
      tag_keys_condition,
      tag_key_values_condition,
    } = row?.criteria;

    const renderTag = (items, label) => {
      return (
        <WrapItem>
          <Tag
            label={
              <CustomTooltip
                label={
                  <Stack spacing={1}>
                    {map(items, r => (
                      <Box>{r}</Box>
                    ))}
                  </Stack>
                }
              >
                <Box>
                  {items?.length} {label}
                  {items?.length > 1 ? 's' : ''}
                </Box>
              </CustomTooltip>
            }
          />
        </WrapItem>
      );
    };

    return (
      <Wrap spacing={1}>
        {!!region && renderTag(region, 'region')}
        {!!resource_groups && renderTag(resource_groups, 'resource group')}
        {!!tag_keys_condition?.key?.length &&
          renderTag(tag_keys_condition?.key, 'tag key')}
        <WrapItem>
          {!!tag_key_values_condition && (
            <Tag
              label={
                <CustomTooltip
                  label={
                    <Stack spacing={1}>
                      {map(tag_key_values_condition, r => (
                        <HStack spacing={1}>
                          <Box color="orange.300">{r?.key}:</Box>
                          <Box>{r?.value?.join(', ')}</Box>
                        </HStack>
                      ))}
                    </Stack>
                  }
                >
                  <Box>
                    {tag_key_values_condition?.length} {'tag key + value'}
                  </Box>
                </CustomTooltip>
              }
            />
          )}
        </WrapItem>
      </Wrap>
    );
  } else return '-';
};
